import { createElement as h } from "react"

import { makeStyles, styled } from "@mui/styles"
import T from "prop-types"
import { not, pathOr, prop } from "ramda"

const Element = styled("div")({ fontSize: 12, paddingTop: 2 })

const useStyles = makeStyles(({ palette }) => ({
  root: ({ color, shade, visible }) => ({
    color: pathOr(color, [color, shade], palette),
    display: not(visible) && "none",
  }),
}))

export const Hint = ({ color = "primary", shade = "main", text, visible = true }) =>
  h(Element, { className: prop("root", useStyles({ color, shade, visible })) }, text)

Hint.protoTypes = {
  color: T.string,
  text: T.string,
  visible: T.bool,
}
